import { TypedAnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { CartImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/cartImpression.trackingInfo";
import {
    StepVariables,
    ToolContext,
    ToolStepTrackingInfo
} from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";

export const track = (
    step: StepVariables,
    context: ToolContext,
    extra?: { cart: CartImpressionTrackingInfo }
) => {
    const event: TypedAnalyticsEvent<ToolStepTrackingInfo> = {
        event: EventType.ToolStep,
        payload: {
            eventData: {
                ...step,
                ...context,
                ...extra
            },
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackSubmit = (
    step: StepVariables,
    context: ToolContext,
    extra?: object
) => {
    const event: TypedAnalyticsEvent<ToolStepTrackingInfo> = {
        event: EventType.ToolStepSubmit,
        payload: {
            eventData: {
                ...step,
                ...context,
                ...extra
            },
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};
